import { render, staticRenderFns } from "./Drm.vue?vue&type=template&id=512e124d&"
import script from "./Drm.vue?vue&type=script&lang=js&"
export * from "./Drm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports